import { render, staticRenderFns } from "./master-table-cell-selection.vue?vue&type=template&id=2f885d67&scoped=true&"
import script from "./master-table-cell-selection.vue?vue&type=script&lang=js&"
export * from "./master-table-cell-selection.vue?vue&type=script&lang=js&"
import style0 from "./master-table-cell-selection.vue?vue&type=style&index=0&id=2f885d67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f885d67",
  null
  
)

export default component.exports